<template>
  <div
      ref="modal"
      tabindex="0"
      class="vac-media-preview"
      @click.stop="closeModal"
      @keydown.esc="closeModal"
  >
    <transition name="vac-bounce-preview" appear>
      <div class="vac-media-preview-container">
        <div
            class="vac-image-preview"
            :style="{
						'background-image': `url('${file.url}')`
					}"
        />
      </div>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'MediaPreview',

  props: {
    file: { type: Object, required: true }
  },

  emits: ['close-media-preview'],

  mounted() {
    this.$refs.modal.focus()
  },

  methods: {
    closeModal() {
      this.$emit('close-media-preview')
    }
  }
}
</script>

